const doc = [({"da":({"js":({"merfoto":({"layout":({"footer":({"write_us":"Skriv til os", "call_us":"Ring til os", "opening_hours":"Åbningstider", "copyright":"Copyright"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;